export default {
      id: "i-analytic-services-06-usage",
      viewBox: "0 0 59 99",
      url: __webpack_public_path__ + "img/sprite.svg#i-analytic-services-06",
      toString: function () {
        return this.url;
      }
    }